(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const allTab = document.querySelector('.tabs a.allTab');
    const otherTabs = document.querySelectorAll('.tabs a:not(.allTab)');

    // Clear all active classes first to prevent flash
    allTab.classList.remove('active');
    otherTabs.forEach((tab) => tab.classList.remove('active'));

    // Highlight correct tab on load
    const isTaggedPage = window.location.href.includes('/tagged/');
    if (!isTaggedPage && allTab) {
      allTab.classList.add('active');
    } else {
      otherTabs.forEach((tab) => {
        if (tab.href === window.location.href || window.location.href.includes(tab.getAttribute('href'))) {
          tab.classList.add('active');
        }
      });
    }

    // Tab click behavior
    otherTabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        allTab.classList.remove('active');
        otherTabs.forEach((t) => t.classList.remove('active'));
        this.classList.add('active');
      });
    });

    if (allTab) {
      allTab.addEventListener('click', function () {
        otherTabs.forEach((t) => t.classList.remove('active'));
        this.classList.add('active');
      });
    }

    // Track last read blog
    const articleLinks = document.querySelectorAll('.blog-card a');
    articleLinks.forEach(link => {
      link.addEventListener('click', function () {
        const articleCard = this.closest('.blog-card');
        const title = articleCard.querySelector('h2 a, h3 a')?.innerText;
        const image = articleCard.querySelector('img')?.src;
        const url = this.href;
        const time = new Date().toLocaleString();

        const lastRead = { title, image, url, time };
        localStorage.setItem('lastReadBlog', JSON.stringify(lastRead));
      });
    });

    // Display last read blog
    const lastReadData = localStorage.getItem('lastReadBlog');
    if (lastReadData) {
      const { title, image, url, time } = JSON.parse(lastReadData);
      const container = document.getElementById('last-read-blog');
      const titleEl = document.getElementById('last-read-title');
      const imageEl = document.getElementById('last-read-image');
      const linkEl = document.getElementById('last-read-link');
      const timeEl = document.getElementById('last-read-time');

      if (container && title && url) {
        titleEl.innerText = title;
        titleEl.href = url;
        imageEl.src = image || '';
        imageEl.alt = title;
        linkEl.href = url;
        timeEl.innerText = `Read on ${time}`;
        container.style.display = 'block';
      }
    }

    // Estimate read time for all blog cards
    const readTimeElements = document.querySelectorAll('.read-time');

    readTimeElements.forEach(el => {
      const text = el.getAttribute('data-article-content');
      if (text) {
        const words = text.trim().split(/\s+/).length;
        const wordsPerMinute = 200;
        const estimatedTime = Math.max(1, Math.ceil(words / wordsPerMinute));
        el.textContent = ` • ${estimatedTime} min read`;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["finance-faqs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.fin-faq-item');

  items.forEach(function (item) {
    var btn = item.querySelector('.fin-faq-q');
    var ans = item.querySelector('.fin-faq-ans');

    if (!btn || !ans) return;

    if (ans.classList.contains('is-open')) {
      ans.style.maxHeight = ans.scrollHeight + 'px';
    }

    btn.addEventListener('click', function () {
      var isOpen = btn.classList.contains('is-open');

      items.forEach(function (other) {
        var otherBtn = other.querySelector('.fin-faq-q');
        var otherAns = other.querySelector('.fin-faq-ans');
        if (otherBtn && otherAns) {
          otherBtn.classList.remove('is-open');
          otherBtn.setAttribute('aria-expanded', 'false');
          otherAns.classList.remove('is-open');
          otherAns.style.maxHeight = null;
        }
      });

      if (!isOpen) {
        btn.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        ans.classList.add('is-open');
        ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  //Adds class to header items within are focused
  document.addEventListener("DOMContentLoaded", function() {
    const headerWrapper = document.querySelector('.header-wrapper');
    const dropdowns = document.querySelectorAll('details.menu-toggle-selector');

    headerWrapper.addEventListener('focusin', function() {
      headerWrapper.classList.add('menu-open-active');
    });
    headerWrapper.addEventListener('focusout', function() {
      headerWrapper.classList.remove('menu-open-active');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
